import { render, staticRenderFns } from "./DestinationImportedWorkEdit.vue?vue&type=template&id=23013045&scoped=true&"
import script from "./DestinationImportedWorkEdit.vue?vue&type=script&lang=js&"
export * from "./DestinationImportedWorkEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23013045",
  null
  
)

export default component.exports